import { useEffect, useState } from "react";

export function useGyroscopePermission() {
  const [permissionNeeded, setPermissionNeeded] = useState(false);
  const [granted, setGranted] = useState(false);

  useEffect(() => {
    const isIOS =
      typeof DeviceOrientationEvent !== "undefined" &&
      typeof DeviceOrientationEvent.requestPermission === "function";

    if (isIOS) {
      setPermissionNeeded(true);
    }
  }, []);

  const requestPermission = async () => {
    try {
      const result = await DeviceOrientationEvent.requestPermission();
      if (result === "granted") {
        setGranted(true);
        setPermissionNeeded(false);
      }
    } catch (e) {
      console.warn("Permissão de giroscópio negada", e);
    }
  };

  return { permissionNeeded, granted, requestPermission };
}
